import React, { PureComponent } from 'react';
import * as d3 from "d3";
import * as dc from "dc";
import * as crossfilter from "crossfilter";

class BarChartForLayers extends PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            dimension:null,
            minRangeN:0,
            maxRangeN:0
        }
    }

    componentWillMount() {
        const { source,dataFieldName} = this.props;
        
        var dataForChart = source;

        var cf = crossfilter(dataForChart.features)

        this.setState({ dimension: cf.dimension(function(d) {return +d.properties[dataFieldName];}) })

      
    }
    componentDidMount() {
        const { id} = this.props;
       
        if(id !== 'transit'){
            this.drawChart();
        }

    }

    componentWillUnmount() {
        // const {  id, handleLayerFilter,value } = this.props;
        // const { dimension,minRangeN, maxRangeN} = this.state;
        // // console.log(id)
        // if(id != 'transit'){
        //     dimension.filterRange([minRangeN,maxRangeN]);

        //     var filteredLayerData = dimension.top(Infinity)
        //     handleLayerFilter(value,filteredLayerData);
        //     //console.log(filteredLayerData)
        //     dimension.filterAll()
        // }
    }


    drawChart = () => {
        const {  id, handleLayerFilter,value,transportationDataFilterRange,
            foodDesertDataFilterRange,
            lossAffordableHousingDataFilterRange,
            risingRentDataFilterRange,
            raceDataFilterRange,
            incomeDataFilterRange,} = this.props;
        const { dimension,} = this.state;
        

        

        // console.log(dataForChart.features);
        // console.log(id);

        //var dimension = cf.dimension(function(d) {return +d.properties[dataFieldName];});
        var range = new dc.BarChart(this.refs[id]);

        var group;

        const mapping = {
            'transportation': () => {
                group = dimension.group(function(d) {return Math.floor(d * 10) ; });
                range.xAxis().tickFormat(function(d) {return d * 10});

            },
            'foodDeserts': () => {
                group = dimension.group(function(d) {return d; });
                range.xAxis().tickValues(d3.range(group.all().length)).tickFormat(function(d) {
                    if (d === 1){
                        return "Food Desert";
                    }
                    else{
                        return "Food Oasis";
                    }
                });

            },
            'transit': () => {
                group = dimension.group(function(d) {return d; });
                
                range.xAxis()
                    .tickValues(d3.range(group.all().length))
                    .tickFormat(function(d) {return d });

            },
            'affordableUnits': () => {
                group = dimension.group(function(d) {return Math.floor(d / 100) ; });
                range.xAxis().tickFormat(function(d) {return d * 100});

            },
            'risingRents': () => {
                group = dimension.group(function(d) {return Math.floor((d-1)*10); });
                range.xAxis().tickFormat(function(d) {return d*10 });

            },
            'race': () => {
                group = dimension.group(function(d) {return Math.floor(d / 10) ; });
                range.xAxis().tickFormat(function(d) {return d*10});

            },
            'income': () => {
                group = dimension.group(function(d) {return Math.floor(d / 20000); });
                range.xAxis().tickFormat(function(d) {return d  * 20+'k'});

            },
        }

        mapping[id]()

        
        

        var minRange = d3.min(group.all(), function(d) { return d.key; })
        var maxRange = d3.max(group.all(), function(d) { return d.key; })

        
        var linear_domain = [minRange -1 , maxRange +1];
        var filteredLayerData;

        const mappingForResetFiltered = {
            'transportation': () => {
                
                if(transportationDataFilterRange[0] !==0 || transportationDataFilterRange[1] !==0 ){
                    dimension.filterRange([transportationDataFilterRange[0],transportationDataFilterRange[1]]);
                     filteredLayerData = dimension.top(Infinity)
                    // console.log(transportationDataFilterRange)
                    handleLayerFilter(value,filteredLayerData,transportationDataFilterRange[0],transportationDataFilterRange[1],id);
                }else{
                    dimension.filterRange([linear_domain[0]/10,linear_domain[1]/10]); 
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,linear_domain[0]/10,linear_domain[1]/10,id);
                }
            },
            'foodDeserts': () => {
                if(foodDesertDataFilterRange[0] !==0 || foodDesertDataFilterRange[1] !==0 ){
                    dimension.filterRange(foodDesertDataFilterRange);
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,foodDesertDataFilterRange[0],foodDesertDataFilterRange[1],id);
                }else{
                dimension.filterRange([linear_domain[0],linear_domain[1]]); 
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,linear_domain[0],linear_domain[1],id);
                }
            },
            'affordableUnits': () => {
                if(lossAffordableHousingDataFilterRange[0] !==0 || lossAffordableHousingDataFilterRange[1] !==0 ){
                    dimension.filterRange([lossAffordableHousingDataFilterRange[0],lossAffordableHousingDataFilterRange[1]]);
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,lossAffordableHousingDataFilterRange[0],lossAffordableHousingDataFilterRange[1],id);
                }else{
                dimension.filterRange([linear_domain[0]*100,linear_domain[1]*100]); 
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,linear_domain[0]*100,linear_domain[1]*100,id);
                }
            },
            'risingRents': () => {
                if(risingRentDataFilterRange[0] !==0 || risingRentDataFilterRange[1] !==0 ){
                    dimension.filterRange([risingRentDataFilterRange[0],risingRentDataFilterRange[1]]);
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,risingRentDataFilterRange[0],risingRentDataFilterRange[1],id);
                }else{
                dimension.filterRange([linear_domain[0]/10+1,linear_domain[1]/10+1]); 
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,linear_domain[0]/10+1,linear_domain[1]/10+1,id);
                }
            },
            'race': () => {
                if(raceDataFilterRange[0] !==0 || raceDataFilterRange[1] !==0 ){
                    dimension.filterRange([raceDataFilterRange[0],raceDataFilterRange[1]]);
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,raceDataFilterRange[0],raceDataFilterRange[1],id);
                }else{
                dimension.filterRange([linear_domain[0]*10,linear_domain[1]*10]); 
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,linear_domain[0]*10,linear_domain[1]*10,id);
                }
            },
            'income': () => {
                if(incomeDataFilterRange[0] !==0 || incomeDataFilterRange[1] !==0 ){
                    dimension.filterRange([incomeDataFilterRange[0],incomeDataFilterRange[1]]);
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,incomeDataFilterRange[0],incomeDataFilterRange[1],id);
                }else{
                    dimension.filterRange([linear_domain[0]*20000,linear_domain[1]*20000]); 
                     filteredLayerData = dimension.top(Infinity)
                    handleLayerFilter(value,filteredLayerData,linear_domain[0]*20000,linear_domain[1]*20000,id);
                }
            },
        }

        mappingForResetFiltered[id]()

        
        
        //console.log(filteredLayerData)
        dimension.filterAll()

     

        range
        //.margins({top: 0, right: 10, bottom: 0, left: 0})
        .width(320).height(100)
        .x(d3.scaleLinear().domain(linear_domain))
        .xUnits(dc.units.integers)
        .brushOn(true)
        .dimension(dimension)
        .group(group)
        .elasticY(true)
        .controlsUseVisibility(true)
        .transitionDuration(0)
        .centerBar(true)
        .colors('#188FA7') ;

          
        range.yAxis().ticks(2);

        dc.renderAll();

     
        if(id==='transportation'){
            if(transportationDataFilterRange[0] !==0 || transportationDataFilterRange[1] !==0 ){
                range.filter([transportationDataFilterRange[0]*10,transportationDataFilterRange[1]*10])
            }else{
                range.filter([linear_domain[0],linear_domain[1]]); 
            }
        }else if (id==='foodDeserts'){
            if(foodDesertDataFilterRange[0] !==0 || foodDesertDataFilterRange[1] !==0 ){
                range.filter(foodDesertDataFilterRange)
            }else{
                range.filter([linear_domain[0],linear_domain[1]]); 
            }
        }else if (id==='affordableUnits'){
            if(lossAffordableHousingDataFilterRange[0] !==0 || lossAffordableHousingDataFilterRange[1] !==0 ){
                range.filter([lossAffordableHousingDataFilterRange[0]/100,lossAffordableHousingDataFilterRange[1]/100])
            }else{
                range.filter([linear_domain[0],linear_domain[1]]); 
            }
        }else if (id==='risingRents'){
            // console.log(risingRentDataFilterRange)
            // console.log(linear_domain)
            if(risingRentDataFilterRange[0] !==0 || risingRentDataFilterRange[1] !==0 ){
                range.filter([(risingRentDataFilterRange[0]-1)*10,(risingRentDataFilterRange[1]-1)*10])
            }else{
                range.filter([linear_domain[0],linear_domain[1]]); 
            }
        }else if (id==='race'){
            if(raceDataFilterRange[0] !==0 || raceDataFilterRange[1] !==0 ){
                range.filter([raceDataFilterRange[0]/10,raceDataFilterRange[1]/10])
            }else{
                range.filter([linear_domain[0],linear_domain[1]]); 
            }
        }else if (id==='income'){
            // console.log(incomeDataFilterRange)
            // console.log(linear_domain)
            if(incomeDataFilterRange[0] !==0 || incomeDataFilterRange[1] !==0 ){
                range.filter([incomeDataFilterRange[0]/20000,incomeDataFilterRange[1]/20000])
            }else{
                range.filter([linear_domain[0],linear_domain[1]]); 
            }
        }
       

        
        const mappingForFiltered = {
            'transportation': () => {
                range.on("filtered", function (chart) {
                    dc.events.trigger(function () {
            
                    var chartFilter = chart.filters();
                    if(chartFilter.length> 0){
                        dimension.filterRange([chartFilter[0][0]/10,chartFilter[0][1]/10]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,chartFilter[0][0]/10,
                        chartFilter[0][1]/10,id);
                    
                   //     setStateForFilteredLayerRange(chartFilter,id)
                    }else{
                        
                        dimension.filterRange([linear_domain[0]/10,linear_domain[1]/10]); 
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,linear_domain[0]/10,linear_domain[1]/10,id);
                    }

                     //console.log(filteredLayerData)
                    dimension.filterAll()
                    })
                })
            },
            'foodDeserts': () => {
                range.on("filtered", function (chart) {
                    dc.events.trigger(function () {
                    var chartFilter = chart.filters();
                    if(chartFilter.length> 0){
                        dimension.filterRange([chartFilter[0][0],chartFilter[0][1]]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,chartFilter[0][0],chartFilter[0][1],id);
                       // setStateForFilteredLayerRange(chartFilter,id)
                    }else{
                        dimension.filterRange([linear_domain[0],linear_domain[1]]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,linear_domain[0],linear_domain[1],id);
                    }
                    
                    //console.log(filteredLayerData)
                    dimension.filterAll()
                    })
                })
            },
            // 'transit': () => {
            //     range.on("filtered", function (chart) {
            //         dc.events.trigger(function () {
            //         var chartFilter = chart.filters();
            //         if(chartFilter.length> 0){
            //             dimension.filterRange([chartFilter[0][0]/10,chartFilter[0][1]/10]); 
            //         }else{
            //             dimension.filterRange([minRange/10,maxRange/10]); 
            //         }
            //         var filteredLayerData = dimension.top(Infinity)
            //         handleLayerFilter(value,filteredLayerData);
            //         //console.log(filteredLayerData)
            //         dimension.filterAll()
            //         })
            //     })
            // },
            'affordableUnits': () => {
                range.on("filtered", function (chart) {
                    dc.events.trigger(function () {
                    var chartFilter = chart.filters();
                    if(chartFilter.length> 0){
                        dimension.filterRange([chartFilter[0][0]*100,chartFilter[0][1]*100]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,chartFilter[0][0]*100,chartFilter[0][1]*100,id);
                    
                      //  setStateForFilteredLayerRange(chartFilter,id)
                    }else{
                        dimension.filterRange([linear_domain[0]*100,linear_domain[1]*100]); 
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,linear_domain[0]*100,linear_domain[1]*100,id);
                    }
                    // console.log(filteredLayerData)
                    dimension.filterAll()
                    })
                })
            },
            'risingRents': () => {
                range.on("filtered", function (chart) {
                    dc.events.trigger(function () {
                    var chartFilter = chart.filters();
                    if(chartFilter.length> 0){
                        dimension.filterRange([chartFilter[0][0]/10 + 1,chartFilter[0][1]/10 + 1]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,chartFilter[0][0]/10 + 1,chartFilter[0][1]/10 + 1,id);
                    
                     //   setStateForFilteredLayerRange(chartFilter,id)
                    }else{
                        dimension.filterRange([linear_domain[0]/10+1,linear_domain[1]/10+1]); 
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,linear_domain[0]/10+1,linear_domain[1]/10+1,id);
                    }
                    //console.log(filteredLayerData)
                    dimension.filterAll()
                    })
                })
            },
            'race': () => {
                range.on("filtered", function (chart) {
                    dc.events.trigger(function () {
                    var chartFilter = chart.filters();
                    if(chartFilter.length> 0){
                        dimension.filterRange([chartFilter[0][0]*10,chartFilter[0][1]*10]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,chartFilter[0][0]*10,chartFilter[0][1]*10,id);
               
                     //   setStateForFilteredLayerRange(chartFilter,id)
                    }else{
                        dimension.filterRange([linear_domain[0]*10,linear_domain[1]*10]); 
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,linear_domain[0]*10,linear_domain[1]*10,id);
                    }
                         //console.log(filteredLayerData)
                    dimension.filterAll()
                    })
                })
            },
            'income': () => {
                range.on("filtered", function (chart) {
                    dc.events.trigger(function () {
                    var chartFilter = chart.filters();
                    if(chartFilter.length> 0){
                        dimension.filterRange([chartFilter[0][0]*20000,chartFilter[0][1]*20000]);
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,chartFilter[0][0]*20000,chartFilter[0][1]*20000,id);
                  
                     //   setStateForFilteredLayerRange(chartFilter,id)
                    }else{
                        dimension.filterRange([linear_domain[0]*20000,linear_domain[1]*20000]); 
                         filteredLayerData = dimension.top(Infinity)
                        handleLayerFilter(value,filteredLayerData,linear_domain[0]*20000,linear_domain[1]*20000,id);
                    }
                     // console.log(filteredLayerData)
                    dimension.filterAll()
                    })
                })
            },
        }

        mappingForFiltered[id]()


    }

    render() {
        const { id } = this.props;

        return <div className="chartForLayer" ref={id}></div>
    }
}

export default BarChartForLayers;